/*
 *
 * Login actions
 *
 */

import {
  DEFAULT_ACTION,
  UPDATE_USERNAME,
  UPDATE_PASSWORD,
  SUBMIT_USERNAME,
  SUBMIT_USERNAME_SUCCESS,
  SUBMIT_USERNAME_FAILURE,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  GO_TO_PAGE,
  BACK_TO_EMAIL,
  RESET_STATE,
  RESET_ERROR,
  SET_DOMAIN_AUTH_METHOD,
  REQUIRE_TWO_FA_CODE,
  UPDATE_TWO_FA_CODE,
  SUBMIT_TWO_FA_CODE,
  SUBMIT_TWO_FA_CODE_SUCCESS,
  SUBMIT_TWO_FA_CODE_FAILURE,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export const updateUsername = (username) => ({
  type: UPDATE_USERNAME,
  username,
});

export const updatePassword = (password) => ({
  type: UPDATE_PASSWORD,
  password,
});

export const submitUsername = () => ({
  type: SUBMIT_USERNAME,
});

export const submitUsernameSuccess = (meta) => ({
  type: SUBMIT_USERNAME_SUCCESS,
  ...meta,
});

export const submitUsernameFailure = (error) => ({
  type: SUBMIT_USERNAME_FAILURE,
  error,
});

export const login = (username, password) => ({
  type: LOGIN,
  username,
  password,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  user,
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  error,
});

export const forgotPassword = () => ({
  type: FORGOT_PASSWORD,
});

export const forgotPasswordSuccess = (message) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  message,
});

export const forgotPasswordFailure = (error) => ({
  type: FORGOT_PASSWORD_FAILURE,
  error,
});

export const goToPage = (pageName) => ({
  type: GO_TO_PAGE,
  pageName,
});

export const resetState = () => ({
  type: RESET_STATE,
});

export const backToEmail = () => ({
  type: BACK_TO_EMAIL,
});

export const resetError = () => ({
  type: RESET_ERROR,
});

export const setDomainAuthMethod = (method, identityProviderId) => ({
  type: SET_DOMAIN_AUTH_METHOD,
  method,
  identityProviderId,
});

export const requireTwoFaCode = (userId) => ({
  type: REQUIRE_TWO_FA_CODE,
  userId,
});

export const updateTwoFaCode = (code) => ({
  type: UPDATE_TWO_FA_CODE,
  code,
});

export const submitTwoFaCode = (userId, code) => ({
  type: SUBMIT_TWO_FA_CODE,
  userId,
  code,
});
